package com.essntl.components.sidepanel

import androidx.compose.runtime.Composable

enum class SplitterHandleAlignment {
    Before,
    Above,
    After
}

data class Splitter(
    val measuredPart: @Composable () -> Unit,
    val handlePart: @Composable () -> Unit = measuredPart,
    val alignment: SplitterHandleAlignment = SplitterHandleAlignment.Above
)